export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_USERS: 'SET_USERS',
    SET_SELECTED_USER: 'SET_SELECTED_USER',
    ADD_USER: 'ADD_USER',
    UPDATE_USER: 'UPDATE_USER',
    DELETE_USER: 'DELETE_USER',
    SET_USER_STATUS: 'SET_USER_STATUS',
    ADD_USER_COMMENT: 'ADD_USER_COMMENT',
    UPDATE_USER_APPROVER: 'UPDATE_USER_APPROVER',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE',
    UPDATE_USER_ATTACHMENTS: 'UPDATE_USER_ATTACHMENTS',
    SET_USER_HISTORY: 'SET_USER_HISTORY',
    SET_SEARCH_RESULTS: 'SET_SEARCH_RESULTS',
    SET_USER_ROLES: 'SET_USER_ROLES'
};

export const initialState = {
    searchResults: [],
    users: [],
    selectedUser: null,
    loading: false,
    error: null,
    filter: {
        status: null,
        userType: null,
        dateRange: {
            start: null,
            end: null
        },
        priority: null,
        department: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'createdAt',
        direction: 'desc'
    },
    userHistory: [],
    roles: []
};

export const usersReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_USERS:
            return {
                ...state,
                users: action.payload.content || action.payload,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                loading: false
            };

        case ACTIONS.SET_SELECTED_USER:
            return {
                ...state,
                selectedUser: action.payload,
                loading: false
            };

        case ACTIONS.ADD_USER:
            return {
                ...state,
                users: [action.payload, ...state.users],
                loading: false
            };

        case ACTIONS.UPDATE_USER:
            return {
                ...state,
                users: state.users.map((user) => (user.id === action.payload.id ? action.payload.data : user)),
                selectedUser: state.selectedUser?.id === action.payload.id ? action.payload.data : state.selectedUser,
                loading: false
            };

        case ACTIONS.DELETE_USER:
            return {
                ...state,
                users: state.users.filter((user) => user.id !== action.payload),
                selectedUser: state.selectedUser?.id === action.payload ? null : state.selectedUser,
                loading: false
            };

        case ACTIONS.SET_USER_STATUS:
            return {
                ...state,
                users: state.users.map((user) => (user.id === action.payload.id ? { ...user, status: action.payload.status } : user)),
                selectedUser:
                    state.selectedUser?.id === action.payload.id
                        ? { ...state.selectedUser, status: action.payload.status }
                        : state.selectedUser
            };

        case ACTIONS.ADD_USER_COMMENT:
            return {
                ...state,
                selectedUser: state.selectedUser && {
                    ...state.selectedUser,
                    comments: [...state.selectedUser.comments, action.payload]
                }
            };

        case ACTIONS.UPDATE_USER_APPROVER:
            return {
                ...state,
                selectedUser: state.selectedUser && {
                    ...state.selectedUser,
                    approvers: state.selectedUser.approvers.map((approver) =>
                        approver.approverId === action.payload.approverId ? { ...approver, ...action.payload } : approver
                    )
                }
            };

        case ACTIONS.UPDATE_USER_ATTACHMENTS:
            return {
                ...state,
                selectedUser: state.selectedUser && {
                    ...state.selectedUser,
                    attachments: action.payload
                }
            };

        case ACTIONS.SET_USER_HISTORY:
            return {
                ...state,
                userHistory: action.payload
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        case ACTIONS.SET_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: Array.isArray(action.payload) ? action.payload : [],
                loading: false
            };

        case ACTIONS.SET_USER_ROLES:
            return {
                ...state,
                roles: Array.isArray(action.payload) ? action.payload : [],
                loading: false
            };

        default:
            return state;
    }
};
